var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconContentPencilWrite64X64(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105.977,
    height: 99.236,
    viewBox: "0 0 105.977 99.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-content-pencil-write_64x64",
    "data-name": "streamline-icon-content-pencil-write@64x64",
    transform: "translate(2.5 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M70.89,67.4,32.267,38.185l-5.645-16.2L43.75,23,82.369,52.213a9.491,9.491,0,0,1,1.844,13.3l-.036.045A9.486,9.486,0,0,1,70.89,67.4Z",
    transform: "translate(14.829 8.089)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M69.3,24.305V10.843a6.731,6.731,0,0,0-6.731-6.731H8.72a6.731,6.731,0,0,0-6.731,6.731V78.154A6.731,6.731,0,0,0,8.72,84.886H40.132L55.838,98.348V84.886h6.731a6.731,6.731,0,0,0,6.022-3.72M15.452,17.574H35.645m-10.1,0V37.768M15.452,54.6H32.279M15.452,68.058H42.376",
    transform: "translate(-1.989 -4.112)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconContentPencilWrite64X64);
export default __webpack_public_path__ + "static/media/streamline-icon-content-pencil-write@64x64.604658b1.svg";
export { ForwardRef as ReactComponent };